// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetChatmeterLocationsAPI,  ActionGetChatmeterLocationsAPISuccess,  getChatmeterDeactiveLocationsAPI, getChatmeterLocationsAPI,getChatmeterDeactiveLocationsAPISuccess, getChatmeterLocationsAPIError, getChatmeterDeactiveLocationsAPIError,getChatmeterLocationsAPISuccess, ActionGetChatmeterAccountsAPI, getChatmeterAccountsAPISuccess, getChatmeterAccountsAPIError, ActionAccountAPI, addAccountAPISuccess, addAccountAPIError} from './actions';
import { ChatmeterLocation } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';

function* getChatmeterLocations(action: ActionGetChatmeterLocationsAPI) {
    try {

        const { query, limit, offset } = action

        let urlrequest = `chatmeter/locations?query=${encodeURIComponent(query??"")}`        
        if (limit)
            urlrequest+= `&limit=${limit}`
        if (offset)
            urlrequest+= `&offset=${offset}`

        const { data } = yield call(createAPINetworkInstance().get, urlrequest);
        //const { data } = yield call(createAPINetworkInstance().get, `chatmeter/locations?query=${query}&limit=${limit}&offset=${offset}`);
        //const lmdepartments: UIDepartments = parseAPILMdepartments(data);
        yield put(getChatmeterLocationsAPISuccess(data));        
    } catch (err) {
        yield put(getChatmeterLocationsAPIError(err));
    }
}


function* getChatmeterDeactiveLocations(action: ActionGetChatmeterLocationsAPI) {
    try {

        const { query, limit, offset } = action
        const { data } = yield call(createAPINetworkInstance().get, `chatmeter/deactivatedLocations?query=${encodeURIComponent(query??"")}&limit=${limit}&offset=${offset}`);
        //const lmdepartments: UIDepartments = parseAPILMdepartments(data);
        yield put(getChatmeterDeactiveLocationsAPISuccess(data));        
    } catch (err) {
        yield put(getChatmeterDeactiveLocationsAPIError(err));
    }
}

function* getChatmeterAccounts(action: ActionGetChatmeterAccountsAPI) {
    try {

        const { query} = action
        const { data } = yield call(createAPINetworkInstance().get, `chatmeter/accounts?query=${encodeURIComponent(query??"")}`);
        yield put(getChatmeterAccountsAPISuccess(data));        
    } catch (err) {
        yield put(getChatmeterAccountsAPIError(err));
    }
}


function* addChatmeterAccount(action: ActionAccountAPI) {
    try {

        const { id, accountName } = action
       
        const body = {
            id: id,
            accountName:accountName
        };


        const {data} = yield call(createAPINetworkInstance().post, `chatmeter/accounts`, body);            
        //const lmdepartments: UIDepartments = parseAPILMdepartments(data);
        yield put(addAccountAPISuccess(data));        
    } catch (err) {
        yield put(addAccountAPIError(err));
    }
}

export default function* getChatmeterSagas() {
    yield takeLatest(ACTIONS.GET_CHATMETERLOCATIONS_API_REQUEST, getChatmeterLocations);
    yield takeLatest(ACTIONS.GET_CHATMETERDEACTIVELOCATIONS_API_REQUEST, getChatmeterDeactiveLocations);   
    yield takeLatest(ACTIONS.GET_CHATMETERACCOUNTS_API_REQUEST, getChatmeterAccounts); 
    yield takeLatest(ACTIONS.ADD_CHATMETERACCOUNT_API_REQUEST, addChatmeterAccount); 
}
